import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
import RevisionsEditForm from './../../elements/reports/revisions';
import Loading from "../../elements/loading";
//import {history} from "../../store/store";
//import _ from "lodash";

class ReportRevisions extends Component{
	render(){
		let { notification_messages } = this.props;
		return(
			notification_messages.isFetching ? <Loading/>:<RevisionsEditForm {...this.props}/>
		);
	}

	componentWillMount() {
		let {modality} = this.props.match.params;
		this.props.fetchNotificationMessages(modality);
	}

	componentWillReceiveProps(nextprops) {
		if(nextprops.match.params.modality !== this.props.match.params.modality) {
			let {modality} = nextprops.match.params;
			this.props.fetchNotificationMessages(modality);
		}
	}
}

export default BaseLayout(ReportRevisions,{title:"Reporte de Revisiones", subnav:{icon: 'fa-tasks', name: 'Reportes' }, stateNav: true})


// WEBPACK FOOTER //
// ./src/layouts/reports/revisions.jsx